import { ClientApiConfig } from '@quadminds/client-apis/base';

export type IntegrationsApiConfig = ClientApiConfig;

export interface Criteria {
    _id: string;
    userId: string;
    provider: string;
    criteria: {
        pickupZone: {
            path: { lat: number; lng: number }[];
        };
    };
}

export interface ProviderAuthorization {
    url: string;
}

export type Provider = {
    id: string;
    name: string;
    available: boolean;
    icon: string;
    completed: boolean;
};
